import { Button } from "@/components/ui/button";
import { LogOut } from "lucide-react";
import React from "react";
import { useNavigate } from "react-router-dom";


const MasterAdminNavigation = () => {
      const navigate = useNavigate();
   const handleLogout = () => {
    localStorage.clear();
    navigate("/");
  };
    return (
      
        <nav className="floating-nav">
        <div className="flex items-center justify-between gap-6">
          <button onClick={() => navigate("/master/dashboard")} className="text-[#1A3C34] font-bold text-xl" style={{width:'120px'}}>
            <img src="../parkioo_logo.png" alt="Parkioo Logo" className="w-full object-contain p-2" style={{height:'51px'}}/>
          </button>
          <div className="flex gap-4">
            <Button
              data-testid="admin-nav-dashboard"
              onClick={() => navigate("/master/dashboard")}
              variant="ghost"
              className="text-[#1A3C34] hover:bg-[#F5F2EB] rounded-full"
            >
              Dashboard
            </Button>
            <Button
              data-testid="admin-nav-users"
              onClick={() => navigate("/master/AllClients")}
              variant="ghost"
              className="text-[#1A3C34] hover:bg-[#F5F2EB] rounded-full"
            >
              All Clients
            </Button>
            <Button
              data-testid="admin-nav-slots"
              onClick={() => navigate("/master/payments")}
              variant="ghost"
              className="text-[#1A3C34] hover:bg-[#F5F2EB] rounded-full"
            >
              Payments
            </Button>
            <Button
              data-testid="admin-nav-logout"
              onClick={handleLogout}
              variant="ghost"
              className="text-[#1A3C34] hover:bg-[#F5F2EB] rounded-full"
            >
              <LogOut size={20} />
            </Button>
          </div>
        </div>
      </nav>
    );
};

export default MasterAdminNavigation;